<template>
  <div class="businesses-list container">
    <div class="row justify-content-center">
      <div class="col-11 col-lg-9">
        <div class="pb-5 pb-md-0">
          <div class="container">
            <div class="row">
              <div
                class="col px-0 d-flex justify-content-between align-items-center mb-4"
              >
                <h3 class="title text-white">Todas las marcas comerciales</h3>

                <router-link
                  class="button button-secondary text-white text-decoration-none"
                  to="/admin"
                  v-if="isSuperAdmin"
                >
                  <i class="ri-settings-2-line"></i>
                  Administrar
                </router-link>
              </div>
            </div>
            <div class="row">
              <!-- TODO hiding add business button for now -->
              <!--  <div class="col-md-4 px-md-2">
                <b-button
                  class="
                    card-add
                    d-block
                    border-0
                    animate__animated animate__fadeIn
                    bg-white
                  "
                >
                  <div
                    class="
                      h-100
                      d-flex
                      justify-content-center
                      align-items-center
                      text-center
                    "
                  >
                    <div class="add-img">
                      <img
                        src="@/core/assets/images/businesses/plus.svg"
                        alt="Icono para agregar empresa"
                        class="d-inline-block"
                      />

                      <h3 class="card-text">
                        Agregar marca comercial
                      </h3>
                    </div>
                  </div>
                </b-button>
              </div>-->
              <!-- Card empresa -->
              <div
                class="col-md-4 px-md-0"
                v-for="(business, key) in businessList"
                :key="key"
              >
                <BusinessCard :business="business" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Alert } from 'wize-admin'
import BusinessCard from "./BusinessCard";
import { mapGetters } from "vuex";

import { BrandService } from "@/core/services"

export default {
  name: "BusinessesList",
  async beforeMount() {
    await this.loadData();
  },
  data() {
    return {
      list: []
    };
  },
  components: {
    BusinessCard,
  },
  methods: {
    async loadData() {
      try {
        await this.$store.dispatch("app/loading", true);

        const params = {page: 0, size: 100};
        const data = {search: ''};

        const response = await BrandService.list(data, params);

        this.list = response.payload.content
      } catch (error) {
        console.log(Alert);
        console.log(error);
        Alert.error(error);
      } finally {
        await this.$store.dispatch("app/loading", false);
      }
    }
  },
  computed: {
    ...mapGetters({
      businesses: "app/getBusinesses",
      user: "auth/getUser",
      isSuperAdmin: 'auth/isSuperAdmin',
      isAdmin: 'auth/isAdmin'
    }),
    businessList() {
      return this.isSuperAdmin ? this.list: this.businesses;
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '../Styles/businesses-list';
</style>